import { useState } from "react";
import DriverCoachingDataTiles from "./components/DriverCoachingDataTiles";
import DriverCoachingDataTable from "./components/DriverCoachingDataTable";

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

export default function DriverCoaching() {
    const [tileData, setTilesData] = useState<ColumnObjType>()
    const handleTiles = (data: ColumnObjType) =>{
      setTilesData(data)
    }

  return (
    <div className="flex flex-col gap-4 mt-4">
      {/* <div className="flex-1">
        <DriverCoachingDataTiles  data={tileData}  />
      </div> */}
      <div className="flex-1 tripTable">
        <DriverCoachingDataTable handleTile={handleTiles}  />
      </div>
    </div>

  );
}